import CustodyScanForm, { type CustodyFormConfig, type CustodyRow } from './CustodyScanForm';
import { type AppColumn } from '../../components/AppDataGrid';
import { fmtLocalDateTime } from '../../utils/datetime';

// Sample Location — READ-ONLY "scan to find where it is" (ALPACA parity,
// SampleCustodyTest_DetailView_SampleLocation): scan a bottle → show its latest
// custody row. No Save, no Unlink. Prototype grid:
// SampleBottleID · Storage · User · Mode · Hazardous · DateHandled · HandledBy.
const modeVariant = (m: string) => {
  const s = m.toLowerCase();
  if (s === 'in') return 'ok';
  if (s === 'out') return 'info';
  if (s === 'disposed' || s === 'depleted') return 'alert';
  return 'warn';
};

const COLUMNS: AppColumn<CustodyRow>[] = [
  { field: 'bottle',    header: 'SampleBottleID', width: 170 },
  { field: 'storage',   header: 'Storage',        width: 150, text: r => r.storage || '—' },
  { field: 'user',      header: 'User',           width: 130, text: r => r.user || '—' },
  { field: 'mode',      header: 'Mode', width: 100, render: r => <span className={`bl-pill ${modeVariant(r.mode)}`}>{r.mode}</span>, text: r => r.mode },
  { field: 'haz',       header: 'Hazardous',      width: 100,
    render: r => <input type="checkbox" checked={r.haz} disabled readOnly />,
    text: r => (r.haz ? 'Yes' : 'No') },
  { field: 'scannedAt', header: 'DateHandled',    width: 160, text: r => fmtLocalDateTime(r.scannedAt) },
  { field: 'by',        header: 'HandledBy',      width: 130 },
];

const CONFIG: CustodyFormConfig = {
  pageId:         'sample-location',
  breadcrumbLeaf: 'Sample Location',
  subtitle:       'Scan a bottle barcode to find where it is',
  actionLabel:    '',
  confirmTitle:   '',
  confirmMessage: '',
  successVerb:    '',
  formName:       'Sample Location',
  readOnly:       true,
  columns:        COLUMNS,
  resolveUrl:     '/api/v1/sample-custody/resolve-location',
  emptyPrompt:    'No data to display — scan a barcode above.',
  buildRow: (r, ctx) => ({
    id:             `${r.sampleBottleId}-${ctx.nowIso}-${Math.round(performance.now())}`,
    bottle:         r.sampleBottleId ?? '',
    from:           '',
    to:             '',
    scannedAt:      r.dateHandled ?? ctx.nowIso,
    by:             r.handledByName ?? '',
    haz:            !!r.hazardous,
    mode:           r.mode ?? '',
    deplete:        false,
    wasteDrum:      '',
    storage:        r.storage ?? '',
    user:           r.user ?? '',
    sampleLoginOid: null,
    jobOid:         null,
    client:         r.client ?? null,
  }),
};

export default function SampleLocationPage() {
  return <CustodyScanForm config={CONFIG} />;
}
